import { Box, Typography } from "@mui/material";

const ColorIndicator = ({ index, color, label }) => {
  return (
    <Box display="flex" alignItems="center" mt={index === 0 ? 0 : 1}>
      <Box
        sx={{
          width: 10,
          height: 10,
          borderRadius: "50%",
          backgroundColor: color,
          mr: 1,
        }}
      />
      <Typography style={{ fontSize: 12 }}>{label}</Typography>
    </Box>
  );
};

export default ColorIndicator;
